import axios from "axios";

const axiosConfig = {
    baseURL: process.env.REACT_APP_BASE_URL,
    timeout: 30000,
};

export const axiosInstance = axios.create(axiosConfig)